import React from 'react';
import c from 'classnames';

import { SearchConfigure, SearchkitWrapper } from '@uncinc/react-searchkit';
import { SearchParameters } from '@uncinc/react-searchkit/types';
import { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import {
  APP_OPTIONS,
  SEARCHKIT_HITS_PER_PAGE_TEAM,
  SEARCHKIT_HOST_URL,
} from '../../config/constants';

// Subcomponents.
import ActiveFacets from './ActiveFacets';
import Facets from './Facets';
import Results from './Results';

import './style.scss';
import SearchBar from './SearchBar';

interface SearchTeamSubComponents {
  ActiveFacets: typeof ActiveFacets;
  Facets: typeof Facets;
  Results: typeof Results;
  SearchBar: typeof SearchBar;
}

export interface SearchTeamProps extends Omit<SearchkitWrapperProps, 'connection' | 'searchSettings' | 'indexName'> {
  className?: string;
}

const SearchTeam: React.FC<SearchTeamProps> & SearchTeamSubComponents = (props) => {
  const {
    className,
    children,
    ...restProps
  } = props;

  const classNames = c('SearchTeam', className);

  const searchAttributes = [
    'field_full_name',
    'field_full_name_fulltext',
    'field_team',
    'field_function',
  ];

  const resultAttributes = [
    'field_email_address',
    'field_telephone',
    'field_full_name',
    'field_full_name_fulltext',
    'image_style_uri',
    'field_function',
    'field_team',
    'field_employee',
  ];

  const searchParameters: SearchParameters = {
    filters: 'employee:true',
  };

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{
        host: SEARCHKIT_HOST_URL,
      }}
      indexName={APP_OPTIONS.parameters.searchkitIndexTeam}
      hitsPerPage={SEARCHKIT_HITS_PER_PAGE_TEAM}
      searchSettings={{
        search_attributes: searchAttributes,
        result_attributes: resultAttributes,
        filter_attributes: [
          {
            attribute: 'employee',
            field: 'field_employee',
            type: 'string',
          },
        ],
        facet_attributes: [
          {
            attribute: 'team',
            field: 'field_team',
            type: 'string',
            facetQuery: (
              field,
              size,
            ) => ({
              terms: {
                field,
                size,
                min_doc_count: 0,
              },
            }),
          },
        ],
        sorting: {
          default: {
            field: 'field_full_name',
            order: 'asc',
          },
        },
      }}
    >
      <SearchConfigure
        {...searchParameters}
      />
      {children}
    </SearchkitWrapper>
  );
};

SearchTeam.ActiveFacets = ActiveFacets;
SearchTeam.Facets = Facets;
SearchTeam.Results = Results;
SearchTeam.SearchBar = SearchBar;

export default SearchTeam;
